import { Component } from '@angular/core';
import { BaseTechnicalSectionComponent } from '../../common/base-technical-section.component';
import { FormatterData } from 'src/app/constants/app.constants';
import { GridApplicationCommentsService } from 'src/app/+grid-application-shared/services/grid-application-comments.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { ControlContainer, NgForm } from '@angular/forms';
import { NetzTranslateService } from 'src/app/services/netz-translate.service';

@Component({
  selector: 'app-feed-in-controllability',
  templateUrl: './feed-in-controllability.component.html',
  styleUrls: ['./feed-in-controllability.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FeedInControllabilityComponent extends BaseTechnicalSectionComponent {
  dateFormat = FormatterData.date;
  minDate = new Date();

  public readonly feedInManagementValues = {
    noManagement: 'noManagement',
    limit60Perc: 'limit60Perc',
    limit60PercPowerAndControl: 'limit60PercPowerAndControl',
    controlViaRadio: 'controlViaRadio',
    controlViaControlUnit: 'controlViaControlUnit',
  };

  constructor(
    commentService: GridApplicationCommentsService,
    environmentService: EnvironmentService,
    private translateService: NetzTranslateService
  ) {
    super(commentService, environmentService);
  }

  protected get sectionComment(): string | null {
    return this.technicalData.technical_specifications_sections_state?.feed_in_controllability_comment;
  }

  protected set sectionComment(value: string | null) {
    this.technicalData.technical_specifications_sections_state.feed_in_controllability_comment = value;
  }

  protected get sectionLocked(): boolean | null {
    return this.technicalData.technical_specifications_sections_state?.is_feed_in_controllability_locked;
  }

  protected set sectionLocked(value: boolean | null) {
    this.technicalData.technical_specifications_sections_state.is_feed_in_controllability_locked = value;
  }

  public get isNoManagementDisabled() {
    if (this.environmentService.enableFeedInControllabilityOptions) {
      return false;
    }
    return this.technicalData.total_power_pv_modules > 1.999;
  }

  public get isLimit60PercDisabled() {
    if (this.environmentService.enableFeedInControllabilityOptions) {
      return false;
    }
    return this.technicalData.total_power_pv_modules < 1.999 || this.technicalData.total_power_pv_modules > 24.999;
  }

  public get isLimit60PercPowerAndControllabilityDisabled() {
    if (this.environmentService.enableFeedInControllabilityOptions) {
      return false;
    }
    return this.technicalData.total_power_pv_modules < 24.999 || this.technicalData.total_power_pv_modules > 99.999;
  }

  public get isControlViaRadioDisabled() {
    if (this.environmentService.enableFeedInControllabilityOptions) {
      return false;
    }
    return this.technicalData.total_power_pv_modules < 99.999 || this.technicalData.total_power_pv_modules > 499.999;
  }

  public get isControlViaControlUnitDisabled() {
    if (this.environmentService.enableFeedInControllabilityOptions) {
      return false;
    }
    return this.technicalData.total_power_pv_modules < 499.999;
  }

  public get noManagementTooltip(): string | null {
    return !this.environmentService.enableFeedInControllabilityOptions
      ? this.translateService.translateString('grid-comp.no-feed-in-tooltip')
      : null;
  }

  public get limit60PercTooltip(): string | null {
    return !this.environmentService.enableFeedInControllabilityOptions
      ? this.translateService.translateString('grid-comp.limit-60-perc-tooltip')
      : null;
  }

  public get limit60PercPowerAndControllabilityTooltip(): string | null {
    return !this.environmentService.enableFeedInControllabilityOptions
      ? this.translateService.translateString('grid-comp.limit-60-perc-power-and-controllability-tooltip')
      : null;
  }

  public get controlViaRadioTooltip(): string | null {
    return !this.environmentService.enableFeedInControllabilityOptions
      ? this.translateService.translateString('grid-comp.control-via-radio-tooltip')
      : null;
  }

  public get controlViaControlUnitTooltip(): string | null {
    return !this.environmentService.enableFeedInControllabilityOptions
      ? this.translateService.translateString('grid-comp.control-via-control-unit-tooltip')
      : null;
  }
}
